export default __webpack_public_path__ + "static/media/rari_fuse.613bcdb4.png";